import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class TooltipService {
  components: any[] = [];
  tooltipPosition: any = {
    x: '',
    y: ''
  };
  private tooltipPositionChanged: BehaviorSubject<any> = new BehaviorSubject(this.tooltipPosition);
  public emitter: Observable<any> = this.tooltipPositionChanged.asObservable();

  public updateTooltipPosition(x: number, y: number): void {
    const deviationX = 0; // TODO: maybe something based on movement direction?
    const deviationY = -40;

    this.tooltipPosition.x = x + deviationX;
    this.tooltipPosition.y = y + deviationY;
    this.setTooltipPosition(this.tooltipPosition);
  }

  public setTooltipPosition(tooltipPosition: any): void {
    this.tooltipPositionChanged.next(tooltipPosition);
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/tooltips/tooltip.service.ts